<div class="w-full h-full">
  <p-scroll-panel [style]="{width:'100%', height:'100%'}">
    <ng-content></ng-content>
  </p-scroll-panel>
</div>
